import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';

import './TopMenu.css';

class TopMenu extends React.Component {

  static propTypes = {
    className: PropTypes.string
  };

  render() {
    return (
      <nav className={classnames('TopMenu', this.props.className)}>
        <ul className="TopMenu__menuItems">
          {
            [
              {
                title: <FormattedMessage id="TopMenu.home"/>,
                to: `/`
              },
              {
                title: <FormattedMessage id="TopMenu.company"/>,
                to: `/company`
              },
              {
                title: <FormattedMessage id="TopMenu.history"/>,
                to: `/history`
              },
              {
                title: <FormattedMessage id="TopMenu.salesItems"/>,
                to: `/sales-items`
              },
              {
                title: <FormattedMessage id="TopMenu.contact"/>,
                to: `/contact`
              },
            ].map(({ title, to }) => (
              <li
                key={to}
                className="TopMenu__menuItem">
                <NavLink
                  className="TopMenu__menuItemLink"
                  exact
                  to={to}
                  activeClassName="TopMenu__menuItemLink--active">
                  {title}
                </NavLink>
              </li>
            ))
          }
        </ul>
      </nav>
    );
  }

}

export default TopMenu;



// WEBPACK FOOTER //
// ./src/components/TopMenu.js